import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ENV } from "../../../util/env";
import Loader from "../../layout/lodaer";
import { base64urlDecode, base64urlEncode } from "./Base64URL";

const numberOfQuestions = 12;

const RiskAnalyzer = () => {
  const { email, username } = useParams();
  const decodeduseremail = email ? base64urlDecode(email) : "ID not provided";
  const decodedusername = username
    ? base64urlDecode(username)
    : "ID not provided";
    console.log(decodeduseremail , decodedusername);
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [counter, setCounter] = useState(1);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [Totalscore, setTotalscore] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    setLoading(true);

    const fetchQuestions = async () => {
      try {
        const response = await fetch(
          `${ENV.API_URL}/boi_risk_analyzer/getQuestionList`
        );
        const data = await response.json();
        setQuestions(data);
      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  const handleNext = (e) => {
    let inputchecked = document.querySelector(
      `input[name=${e}]:checked`
    )?.value;
    console.log("inputchecked", inputchecked);
    console.log("V", e);
    if (inputchecked == null || inputchecked == undefined) {
      alert("Please select at least one response!");
      // return false;
    } else {
      if (counter === questions.length) {
        setIsSubmit(true);
        submitForm();
      } else {
        setCounter((prev) => prev + 1);
        showElement(`question-${counter + 1}`);
      }
    }
    // if (!validate(e)) return;
  };

  const handleBack = () => {
    if (counter > 1) {
      setCounter((prev) => prev - 1);
      showElement(`question-${counter - 1}`);
      setIsSubmit(false);
    }
  };

  const showElement = (id) => {
    document
      .querySelectorAll(".question-container")
      .forEach((el) => (el.style.display = "none"));
    document.getElementById(id).style.display = "block";
  };

  const [results, setResult] = useState([]);
  const handleonChange = (q, o) => {
    console.log("sanjay", q, o);
    setSelectedOption(o);
    perpareArray(q, o);
  };

  const perpareArray = (q, o) => {
    // let points_selected = event.id.split("-")[1];
    let data_object = {
      questionId: parseFloat(q),
      responseID: o,
      userName: decodedusername,
      userEmail: decodeduseremail,
    };

    setResult((prevData) => [...prevData, data_object]);
    replaceObject(data_object);
  };

  const [newResult, setNewResult] = useState([]);

  const replaceObject = (newObj) => {
    // setameDatasss(prevData => {
    //   // Remove the object with the same id as newObj and add the new object
    //   return prevData.map(obj =>
    //     obj.questionId == newObj.questionId ? newObj : obj
    //   );
    // });

    setNewResult((prevData) => {
      // Remove the object with the same id as newObj
      const filteredData = prevData.filter(
        (obj) => obj.questionId !== newObj.questionId
      );
      // Add the new object
      return [...filteredData, newObj];
    });
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  const submitForm = async () => {
    setLoading(true);
    // const formData = new FormData(document.getElementById("raq_questions"));
    // const questionAnswerResponse = [];
    // for (const [key, value] of formData.entries()) {
    //   if (key.startsWith("questionID")) {
    //     questionAnswerResponse.push({
    //       questionId: parseFloat(value),
    //       responseID: formData.get(`responseID${value}`),
    //       userName: sessionStorage.getItem("RiskAnalyseruserName"),
    //       userEmail: sessionStorage.getItem("RiskAnalyseruserEmail"),
    //     });
    //   }
    // }
    try {
      const response = await fetch(
        `${ENV.API_URL}/boi_risk_analyzer/getScore`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newResult),
        }
      );
      const score = await response.json();
      setTimeout(() => {
        navigate(`/RiskProfile/${base64urlEncode(score)}/${username}/${email}`);
      }, 100);

      // handleScoreResponse(score);
      setTotalscore(score);
      setLoading(false);
    } catch (error) {
      console.error("Error submitting form:", error);
      setTotalscore(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {!loading ? (
        <>
          <div className="container">
          <div class="">
            <div class="content_style" id="idfo">
                <h4 class="head_style">Analyse your Risk %</h4>
                <p class="paragraph_style">We will take you through a simple risk profile questionnaire. Please provide the most suitable responses</p>
            </div>
        </div>
            <form id="raq_questions" className=" quiz-questions-ban-sec">
              {questions.map((q, index) => (
                <div
                  key={index}
                  className="question-container quiz-question-section container risk"
                  id={`question-` + q.id}
                  style={{ display: index === 0 ? "block" : "none" }}
                >
                  <div className="progress-ques">
                    <span className="prog-ques-line">
                      QUESTION {index + 1} OF {questions.length}
                    </span>
                    <div className="progress_bar">
                      <div
                        className="progress-status"
                        style={{
                          width: `${((index + 1) / questions.length) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  <div className="quiz-questions">
                    <span className="quiz-question">
                      Q{index + 1}. {q.question}
                    </span>
                    <div className="quiz-options"></div>
                  </div>
                  {/* <input
                    type="hidden"
                    name={`questionID${q.id}`}
                    value={q.id}
                  /> */}
                  {q.riskProfileResponseBasedScoresDTO.map((response, i) => (
                    <div
                      key={response.questionID + i}
                      className="form-check option questionOptonlabel"
                    >
                      {/* <p
                      key={response.questionID}
                      className="quiz-option"
                      style={{
                        backgroundColor:
                          selectedOption == i+1 ? "#1b6098" : "#e8eff5",
                        color:
                          selectedOption == i+1 ? "#ffffff" : "#000000",
                      }}
                      onClick={() => handleonChange(q.id ,i)}
                    >
                      {response.responseText}
                    </p> */}
                      <input
                        className="form-check-input radio_btn"
                        type="radio"
                        name={`responseID${response.questionID}`}
                        id={`questionOpton${i + 1}${response.questionID}`}
                        value={i + 1}
                        required={true}
                        onChange={() => handleonChange(q.id, i + 1)}
                      />
                      <label
                        className="form-check-label radio_label"
                        htmlFor={`questionOpton${i + 1}${response.questionID}`}
                      >
                        {response.responseText}
                      </label>
                    </div>
                  ))}
                  <div className="quiz-questions">
                    <div className="quiz-btns">
                      <button
                        className="quiz-prev-btn"
                        onClick={() => handleBack()}
                        disabled={counter === 1}
                      >
                        <i className="fa fa-chevron-left"></i> Prev
                      </button>
                      <button
                        className="quiz-next-btn"
                        onClick={() => handleNext(`responseID${index + 1}`)}
                        // disabled={selectedOption === null}
                      >
                        {isSubmit ? "Submit" : "Next "}
                        <i className="fa fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </form>
          </div>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default RiskAnalyzer;
